export default function IconButton({
  icon,
  onClick=()=>null,
  selected=false,
  children,
} :{
  icon: string,
  onClick: () => void,
  selected?: boolean,
  children?: React.ReactNode,
}) {
  return (
    <button className={`w-fit h-fit bg-black rounded-full ${ selected ? "bg-opacity-20 text-white" : "text-black bg-opacity-0" } px-2 py-1 transition duration-500`} onClick={onClick}>
      {icon}
      {children}
    </button>
  )
}
